import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { RouterModule } from '@angular/router';
import { AuthenticationRoutingModule } from './authentication-routing.module';
import { SharedModule } from '../shared/shared.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { AuthenticationComponent } from './authentication.component';
import { AuthCallbackComponent } from './auth-callback/auth-callback.component';
import { AuthService, BBSFUtilitiesModule } from 'bbsf-utilities';



@NgModule({
  declarations: [AuthCallbackComponent,AuthenticationComponent],
  imports: [
    CommonModule,
    RouterModule,
    AuthenticationRoutingModule,
    BBSFUtilitiesModule    
  ],
  providers:[
    AuthService
  ]
})
export class AuthenticationModule { }
